
<template>
  <div>
    <v-list>
      <v-list-item-group>
        <template v-for="(prize, idx) in prizes">
          <v-list-item :key="idx" @click="onClick(prize)">
            <template>
              <v-list-item-content>
                <v-list-item-title class="d-flex flex-row justify-space-around">
                    <div class="justify-start align-self-center mr-1">
                      {{prize.place}}. Platz:
                    </div>
                    <div class="flex-grow-1 align-self-center" style="word-break:break-all;white-space:normal;">
                      <prize-widget :prize="prize" />
                    </div>
                    <div class="justify-end align-self-center">
                      <v-btn
                        icon
                        @click="deletePrize($event, prize)"
                        class="secondary warning ml-2"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                </v-list-item-title>
              </v-list-item-content>
            </template>
          </v-list-item>
        </template>
      </v-list-item-group>
    </v-list>
    <add-prize-dialog
            v-if="showAddPrizeDialog"
            :editPrize="editPrize"
            :visible="showAddPrizeDialog"
            :initialPlace="nextPlace"
            :closeAction="function() {showAddPrizeDialog = false;}"
            :confirmAction="prizeDialogConfirmed"
          />
    <v-btn v-if="editable" class="primary" @click="addPrize">
      <v-icon left>mdi-trophy</v-icon>{{$t('common.add')}}
    </v-btn>
  </div>
</template>

<script>
import PrizeWidget from "./PrizeWidget";
import AddPrizeDialog from "./AddPrizeDialog";

export default {
  name: "PrizesWidget",
  components: {
    PrizeWidget,
    AddPrizeDialog
  },
  props: {
    value: Array,
    editable: {
      type: Boolean,
      default: true,
    },
  },
  data: function() {
    return {
      prizes: undefined,
      editPrize: undefined,
      showAddPrizeDialog: false,
    }
  },
  computed: {
    nextPlace: function() {
      var ret = 1;
      this.prizes.forEach((prize) => {
        ret = Math.max(ret, prize.place + 1);
      });
      return ret;
    }
  },
  mounted: function() {
    this.overtakePrizes(this.value)
  },
  watch: {
    prizes: function(val, oldVal) {
      if (oldVal !== undefined) {
        // console.log('emitting new val', val)
        this.$emit('input', val)
      }
    },
    value: function(val) {
      if (val != this.prizes) {
        this.overtakePrizes(val)
      }
    }
  },
  methods: {
    overtakePrizes(prizes) {
      prizes = prizes ? prizes : []
      let newPrizes = []
      prizes.forEach(element => {
        newPrizes.push(element)
      });
      this.prizes = newPrizes;
      // console.log('overtook', newPrizes)
    },
    deletePrize($event, prize) {
      $event.stopPropagation();
      this.prizes = this.prizes.filter((el) => el != prize)
    },
    addPrize() {
      this.editPrize = undefined
      this.showAddPrizeDialog = true;
      // this.prizes.push({'place': 1, type: 'COINS', data: {coins: 100}})
      // this.prizes.push({'place': 1, type: 'CUSTOM', data: {text: 'Custom text'}})
    },
    onClick(prize) {
      this.editPrize = prize
      this.showAddPrizeDialog = true
    },
    prizeDialogConfirmed(prize) {
      if (this.editPrize) {
        this.editPrize.type = prize.type
        this.editPrize.data = prize.data
        this.editPrize.place = prize.place
      } else {
        if (prize.type == 'COINS') {
          let foundEqual = this.prizes.find((el) => {return el.place == prize.place && el.type == prize.type})
          if (foundEqual) {
            foundEqual.data.coins += prize.data.coins;
            return;
          }
        }
        this.prizes.push(prize)
      }
      this.prizes = this.prizes.sort((a, b) => a.place - b.place)
    }
  }
};
</script>